export default "__VITE_ASSET__DjAldMzI__"